// The $ is now locally scoped 

if(typeof Number.prototype.pad2 !== "function"){
    Number.prototype.pad2 = function(){
        return 10>this?"0"+this:""+this
    }
} 




function is_ie() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        return true;
    }
    else  // If another browser, return 0
    {
        return false;
    }

    return false;
}


function is_mozilla() {

    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
        return true;
    }

    return false;
}




function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function strInsert(main_string, ins_string, pos) {
    if(typeof(pos) == "undefined" || typeof(ins_string) == "undefined" || main_string.length <= pos) {
        return main_string
    } 

    return main_string.slice(0, main_string.length - pos) + ins_string + main_string.slice( main_string.length - pos);
}



//  COOKIES

function createCookie(name, value, days) {
    if(days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/"
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
     
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}




//Function  Mask
function mask(o, f) {
    setTimeout(function () {
        var v = f(o.value);
        if (v != o.value) {
            o.value = v;
        }
    }, 1);
}

function mphone(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
    v = v.replace(/(\d)(\d{4})$/, "$1-$2");
    return v;
}

function mdate(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d{2})(\d{4})?/, "$1/$2/$3");
    return v;
}

function mcep(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{5})(\d{3})?/, "$1-$2");
    if(v[v.length - 1] == '-'){
        v = v.slice(0, v.length - 1);
    }   
    return v;
}

function mvalue(v) {
    
        v = v.replace(/\D/g, "");
        // v = parseInt(v);
        var position = 6;
        if(parseInt(v) > 0){
            v = String(v);
            while(v.length < 3){
                v = '0'+v;
            }
            while(v.length > 3 && v[0] == '0'){
                v = v.slice(1,v.length);
            }

            v = v.slice(0, v.length - 2)+','+v.slice(v.length - 2,v.length);
            while(position < v.length){
                v = v.slice(0, v.length - position)+'.'+v.slice(v.length - position,v.length);
                position = position + 4;
            }
        }else{
            v='';
        }
        return v;
}

function mnum(v) {
    v = v.replace(/\D/g, "");
    return v;
}

function memail(v) {
    v = v.replace(/[()+=#%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
    var parts = v.split('@');
    v = "";
    for(var i = 0; i < parts.length; i++){
        if(i == 1){
            v += "@";
        }
        v += parts[i];
    }
    
    return v;
}


function mCNPJ(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
    while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
        v = v.substring(0, v.length - 1);
    }
    return v;
}

function mCPF(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
    while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
        v = v.substring(0, v.length - 1);
    }
    return v;
}

function mRG(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
    
    return v;
}

function mtext(v) {
    v = v.replace(/[0123456789()_+-=#@%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
    return v;
}


function validate_form(form){
    var inputs = $(form).find('input:not(.no-validate)');
    var textareas = $(form).find('textarea:not(.no-validate)');
    var selects = $(form).find('select:not(.no-validate)');

    var error = false;

    inputs.each(function(index, el) {
        if($(el).parents('.form-change-password').length > 0 && !$(el).hasClass('change-password')){
            let regex = /^(?=(?:.*?[A-Z]){0})(?=(?:.*?[0-9]){1})(?=(?:.*?[!@#$%*()_+^&}{:;?.]){0})(?!.*\s)[0-9a-zA-Z!@#$%;*(){}_+^&]*$/; 

            if($(el).parents('.form-change-password').find('.change-password').is(':checked') || $(el).parents('.form-change-password').find('.change-password').length < 1){
                if(el.value == "" || el.value == null ){
                    $(el).addClass('bp-form-error');
                    $(el).parents('.bp-input-label').addClass('bp-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('Esse campo é obrigatório');
                    error = true
                }else{
                    if($(el).hasClass('new-password') ){
                        if(el.value.length < 8){
                            $(el).addClass('bp-form-error');
                            $(el).parents('.bp-input-label').addClass('bp-form-error');
                            $(el).parents('.bp-input-label').find('.bp-error').html('A senha deve conter no minímo 8 digitos!');
                            error = true;
                        }else if(el.value.replace(/\D/g, "").length == 0 || el.value.replace(/\D/g, "").length == el.value.length){
                            $(el).addClass('bp-form-error');
                            $(el).parents('.bp-input-label').addClass('bp-form-error');
                            $(el).parents('.bp-input-label').find('.bp-error').html('A senha deve conter no mínimo 1 número e 1 letra');
                            error = true;

                        }
                    }else if($(el).hasClass('verify-password')){

                        if(el.value != $(el).parents('.form-change-password').find('.new-password').val()){
                            $(el).addClass('bp-form-error');
                            $(el).parents('.bp-input-label').addClass('bp-form-error');
                            $(el).parents('.bp-input-label').find('.bp-error').html('Esse campo deve ser igual a nova senha');
                            error = true;

                        }
                    }
                }

            }

        }else{
            if(el.value == "" || el.value == null ){
                $(el).addClass('bp-form-error');
                $(el).parents('.bp-input-label').addClass('bp-form-error');
                $(el).parents('.bp-input-label').find('.bp-error').html('Esse campo é obrigatório');
                error = true;
            }
        }
    });

    textareas.each(function(index, el) {
        if(el.value == "" || el.value == null ){
            $(el).addClass('bp-form-error');
            $(el).parents('.bp-input-label').addClass('bp-form-error');
            $(el).parents('.bp-input-label').find('.bp-error').html('Esse campo é obrigatório');
            error = true
        }
    });

    selects.each(function(index, el) {
        if(el.value == "" || el.value == null || el.value == "Assunto" || el.value == "Cidade" ){
            $(el).addClass('bp-form-error');
            $(el).parents('.bp-input-label').addClass('bp-form-error');
            $(el).parents('.bp-input-label').find('.bp-error').html('Esse campo é obrigatório');
            // $(el).parents('.select').addClass('bp-form-error');
            error = true
        }
    });

    return error;
}




(function($, window, document) {

	

    var vars_GET = window.location.search.slice(1).split('&').reduce(function _reduce (/*Object*/ a, /*String*/ b) {
                                                                        b = b.split('=');
                                                                        a[b[0]] = decodeURIComponent(b[1]);
                                                                        return a;
                                                                    }, {}
                                                                );
    if(vars_GET.notification){
        window.history.pushState(null, null, window.location.href.replace(window.location.search, "")); 
    }


    // var target = window.location.search;
    // var hasSearch = ((target[0] == '?') || (window.location.href[window.location.href.length - 1] == '?'));

    // target = target.replace('?', '');


    // var targets = target.split("&");
    // for(var i = 0; i < targets.length; i++){
    //     // if(targets[i].split("=")[0] == "solucao_id"){
            

    //     //     window.history.pushState(null, null, window.location.href.replace(window.location.search, "")); 
    //     // }
    // }

    


    if($('.pd-custom-scrollbar').length > 0){
        $(".pd-custom-scrollbar").customScrollbar({
            // skin: "default-skin", 
            hScroll: false,
            vScroll: true,
            // preventDefaultScroll: true,
            updateOnWindowResize: true
        });
    }




    // if($('.list-projects-fullscreen').length > 0){
    //     $('.list-projects-fullscreen').lightGallery({
    //         selector: '.list-projects-item',
    //         download: false,
    //         addClass: 'lg-projects-item',
    //         thumbnail: false,
    //     });
    // }




	$(window).scroll(function(event) {
		if($(window).scrollTop() > 5){
			$('body').addClass('no-top');
		}else{
			$('body').removeClass('no-top');
		}

        if($(window).scrollTop() > ($(window).innerHeight() / 6)){
            $('body').addClass('scrolled');
        }else{
            $('body').removeClass('scrolled');
        }
	});



	$('.bp-header-menu-button').click(function(event) {
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$('.bp-header-menu-close').removeClass('active');
			$('.bp-header-nav').removeClass('active');
			$(this).find('svg').removeClass('active');
			$('body').removeClass('menu-open');
		}else{

			$(this).addClass('active');
			$('.bp-header-menu-close').addClass('active');
			$('.bp-header-nav').addClass('active');
			$(this).find('svg').addClass('active');
			$('body').addClass('menu-open');
		}
	});



	$('.bp-header-menu-close').click(function(event) {
		$(this).removeClass('active');
		$('.bp-header-menu-button').removeClass('active');
		$('.bp-header-nav').removeClass('active');
		$('.bp-header-menu-button svg').removeClass('active');
		$('body').removeClass('menu-open');
	});






    var bp_highlight_home_text_p_height = 0;

	window.addEventListener('resize', function(event){

        if($('header.bp-header-section').length > 0){
            setTimeout(function(){
                $("body").css({
                    'padding-top': ($('header.bp-header-section').innerHeight() - 2)+'px',
                });


                // $(".bp-highlight-home-section").css({
                //     'padding-top': $('header.bp-header-section').innerHeight()+'px',
                // });
            },500);
        }


        

        

		if($(window).innerWidth() > 990){

		}else{

        }



        if($(window).innerWidth() > 767){

            $('.bp-header-menu-close').removeClass('active');
            $('.bp-header-menu-button').removeClass('active');
            $('.bp-header-nav').removeClass('active');
            $('.bp-header-menu-button svg').removeClass('active');
            $('body').removeClass('menu-open');



            
        }else{

           


        }
		
	});

    if($('header.bp-header-section').length > 0){
        setTimeout(function(){
            $("body").css({
                'padding-top': ($('header.bp-header-section').innerHeight() - 2)+'px',
            });

            // $(".bp-highlight-home-section").css({
            //     'padding-top': $('header.bp-header-section').innerHeight()+'px',
            // });

        },500);
    }

    

    $('.menu-item.dropdown').click(function(event) {
        $(this).addClass('open');
    });

    $(document).click(function(event) { 
        var target = $(event.target);
        if(($(target).parents('.select.open').length < 1)){
            setTimeout(function(){
                $('.select.open').removeClass('open');
            },5);
        }


        setTimeout(function(){
            if(($(target).parents('.menu-item.dropdown.open').length < 1) && !$(target).hasClass('dropdown') && !$(target).hasClass('open')){
                    $('.menu-item.dropdown.open').removeClass('open');
            }
        },5);

    });



    $('input[type="tel"],.mask-tel').keypress(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keypress(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keypress(function() {
        mask(this, mcep);
    });

    $('input.mask-value').keypress(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').keypress(function() {
        mask(this, mnum);
    });

    $('input.mask-date').keypress(function() {
        mask(this, mdate);
    });

    $('input.mask-text').keypress(function() {
        mask(this, mtext);
    });

    $('input.mask-rg').keypress(function() {
        mask(this, mRG);
    });

    $('input.mask-cpf').keypress(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keypress(function() {
        mask(this, mCNPJ);
    });



    $('input[type="tel"],.mask-tel').change(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').change(function() {
        mask(this, memail);
    });


    $('input.mask-cep').change(function() {
        mask(this, mcep);
    });

    $('input.mask-value').change(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').change(function() {
        mask(this, mnum);
    });

    $('input.mask-text').change(function() {
        mask(this, mtext);
    });



    $('input[type="tel"],.mask-tel').keyup(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keyup(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keyup(function() {
        mask(this, mcep);
    });

    $('input.mask-value').keyup(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').keyup(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keyup(function() {
        mask(this, mtext);
    });


    $(".mask-cpf-cnpj").keydown(function(event){
        if(event.keyCode == 8){

            var v = this.value.trim();
            v = v.replace(/\./g, '');
            v = v.replace('-', '');
            v = v.replace('/', ''); 
            v = v.replace('.', ''); 

            if(v.length < 13){

                mask(this, mCPF);
            }else{

                mask(this, mCNPJ);
            }
        }

    });


    $(".mask-cpf-cnpj").keypress(function(){

        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 

        if(v.length < 11){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }

    });


    $(".mask-cpf-cnpj").change(function(event ){


        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 


        if(v.length < 12){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }
        

    });


    $(".mask-cpf-cnpj").each(function(index, el){
        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.split('');

        if(v.length < 12){

            mask(el, mCPF);
        }else{

            mask(el, mCNPJ);
        }
    });


    $('input.mask-cpf').each(function(index, el){
        mask(el, mCPF);
    });
    $('input.mask-cnpj').each(function(index, el){
        mask(el, mCNPJ);
        
    });






    // Set recaptcha token to input
    if(typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {

            grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
                var i = $('input.bp-g-recaptcha-t');
                i.val(token);
            });

            setInterval(function(){
                grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
                    var i = $('input.bp-g-recaptcha-t');
                    i.val(token);
                });
                
            },100000);

        });
    }



    $("form:not(.no-validate) select:not(.no-validate)").each(function(index, el) {
        var option = $(this).find('option')[0];
        if(option.value == ''){
            $(option).attr({
                disabled: 'true',
                selectec: 'true'
            });
        } 

        $(this).change(function(event) {
            $(this).addClass('changed');
        });
    });


    $("form:not(.no-validate)").submit(function(event) {

        if($(this).hasClass('wpcf7-form')){

            $(this).find('input[type=submit]').attr({ disabled: '' });
            $(this).addClass('loading');
        }

       


        if(validate_form(this)){
            event.preventDefault();
        }
    });



    function clear_form_errors(form){

        var inputs = $(form).find('input');
        var textareas = $(form).find('textarea');
        var selects = $(form).find('select');

        

        inputs.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('bp-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.bp-input-label').removeClass('bp-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                    // console.log($(el).parent().find('.wpcf7-not-valid-tip'));
                }
            });
            
        });

        textareas.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('bp-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.bp-input-label').removeClass('bp-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                }
            });
        });

        selects.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null && el.value != "UF" && el.value != "Cidade" ){
                    $(el).removeClass('bp-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.bp-input-label').removeClass('bp-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                    // $(el).parents('.select').removeClass('bp-form-error');
                    // $(el).parents('.select-container').find('.wpcf7-not-valid-tip').remove();
                }
            });
        });
    }



    function force_clear_form_errors(form){

        var inputs = $(form).find('input');
        var textareas = $(form).find('textarea');
        var selects = $(form).find('select');

        

        inputs.each(function(index, el) {
            $(el).removeClass('bp-form-error');
            $(el).removeClass('wpcf7-not-valid');
            $(el).parents('.bp-input-label').removeClass('bp-form-error');
            $(el).parents('.bp-input-label').find('.bp-error').html('');
            $(el).parent().find('.wpcf7-not-valid-tip').remove();
        });

        textareas.each(function(index, el) {
            $(el).removeClass('bp-form-error');
            $(el).removeClass('wpcf7-not-valid');
            $(el).parents('.bp-input-label').removeClass('bp-form-error');
            $(el).parents('.bp-input-label').find('.bp-error').html('');
            $(el).parent().find('.wpcf7-not-valid-tip').remove();
        });

        selects.each(function(index, el) {
            $(el).removeClass('bp-form-error');
            $(el).removeClass('wpcf7-not-valid');
            $(el).parents('.select').removeClass('bp-form-error');
            $(el).parents('.select-container').find('.wpcf7-not-valid-tip').remove();
        });
    }


    $("form").each(function(event) {
        clear_form_errors(this);

    });





    $("form.wpcf7-form").submit(function(event) {
        $(this).find('input[type=submit]').attr({ disabled: '' });
        $(this).addClass('loading');
    });


    //Function to redirect form after submit
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        var link = $(event.srcElement).parents('[data-thanks-link]').data('thanks-link');
        var time = $(event.srcElement).parents('[data-thanks-time]').data('thanks-time');
        var files = $(event.srcElement).parents('[data-files-download]').data('files-download');

        $(event.srcElement).find('[type=submit]').addClass('successful');
        $(event.srcElement).find('[type=submit]').prop("disabled",false);

        setTimeout(function(){
            $(event.srcElement).find('[type=submit]').removeClass('successful');
        },10000);
        if(link){
            if(time === 0 || time === "0" || parseInt(time) > 0){

            }else{
                time = 5000;
            }
            setTimeout(function(){
                location = link;
            },time);
        }

        if(files){
            var files_anchor = document.createElement("a");
            files_anchor.download = '';
            document.body.appendChild(files_anchor);

            files.forEach(function(el){
                files_anchor.href = el;
                files_anchor.click();
                window.open(el);
            });
            document.body.appendChild(files_anchor);
        }

    }, false );
    //End
    

    //libera botão de submit
    document.addEventListener( 'wpcf7invalid', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
        $('.input-label .wpcf7-not-valid').each(function(index, el) {
            $(el).parents('.input-label').addClass('bp-form-error')
        });
    }, false );
    

    //libera botão de submit
    document.addEventListener( 'wpcf7spam', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
        $('.input-label .wpcf7-not-valid').each(function(index, el) {
            $(el).parents('.input-label').addClass('bp-form-error')
        });
    }, false );
    

    //libera botão de submit
    document.addEventListener( 'wpcf7mailfailed', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
        $('.input-label .wpcf7-not-valid').each(function(index, el) {
            $(el).parents('.input-label').addClass('bp-form-error')
        });
    }, false );



    //Remove carregando
    document.addEventListener( 'wpcf7submit', function( event ) {
        $(event.srcElement).find('form.wpcf7-form').removeClass('loading');
    }, false );


    







    window.addEventListener('scroll', function(e) {
        if(!is_ie() && ($(window).innerWidth() > 767)){
            var position = window.scrollY || window.pageYOffset || document.body.scrollTop;
            var windowH = window.innerHeight;

        }
    });
    


    if (typeof map_section_infos !== 'undefined') {

        if( $('#bp-map').length > 0){


            var map_args = {
                zoom: 3,
                center: { lat: -23.4669886, lng: -46.5294834 },
            };

           
        
            var map = new google.maps.Map(document.getElementById("bp-map"), map_args);

            if(map_section_infos && map_section_infos['items']){

                var map_section_infos_items = map_section_infos['items'];

                var markers = [];
                var bounds = new google.maps.LatLngBounds();
                var infoWindow = new google.maps.InfoWindow();

                var service = new google.maps.DistanceMatrixService();



                map_section_infos_items.forEach(function(el, i){

                    let marker_args =   {
                                            position: { lat: el['coords'][0], lng: el['coords'][1] },
                                            map: map,
                                        };

                    if(map_section_infos['icon']){
                        marker_args.icon = map_section_infos['icon'];
                    }

                    if(el['title']){
                        marker_args.title = el['title'];
                    }

                    var marker = new google.maps.Marker(marker_args);

                    marker.addListener("click", () => {
                        infoWindow.close();
                        infoWindow.setContent(el['items']);
                        infoWindow.open(marker.getMap(), marker);
                    });
                    
                    markers.push(marker);
                    
                    bounds.extend(marker.position);
                });

                map.fitBounds(bounds);


                $('#bp-map').parent().find('.list [data-coords]').click(function(event) {
                    let coords = $(this).data('coords');
                    if(coords && coords[0] && coords[1]){
                        map.setCenter({ lat: coords[0], lng: coords[1] });
                        map.setZoom(17);

                        infoWindow.close();

                    }
                });

                
  

                $('#bp-map').parent().find('.bp-map-search-container .map-search-btn').click(function(event) {
                    let btn = $(this);
                    let input_cep = btn.parent().find('.map-search-cep');
                    let input_raio = btn.parent().find('.map-search-raio');
                    let input_type = btn.parent().find('.map-search-type');
                    let list = $('#bp-map').parent().find('.list');
                    let items = list.find('[data-cep]');
                    let ceps = [];
                    let ceps_arrays = [[]];
                    let finded = false;
                    let max_elements = 25;


                    if(input_cep.val().length > 2){

                            
                        items.each(function(index, el) {
                            $(el).addClass('item-cep-'+$(el).data('cep').replace(/\D/g, ""));

                            if(ceps_arrays[ceps_arrays.length - 1]){
                                if(ceps_arrays[ceps_arrays.length - 1].length >= max_elements){
                                    ceps_arrays.push([$(el).data('cep')]);
                                }else {
                                    ceps_arrays[ceps_arrays.length - 1].push($(el).data('cep'));
                                }
                            }
                            // ceps.push($(el).data('cep'));
                        });

                        // console.log(ceps_arrays);

                        items.addClass('hidde');

                        
                        // service.getDistanceMatrix({
                        //                             origins: [input_cep.val()],
                        //                             destinations: ceps,
                        //                             travelMode: google.maps.TravelMode.DRIVING,
                        //                             unitSystem: google.maps.UnitSystem.METRIC,
                        //                             avoidHighways: false,
                        //                             avoidTolls: false
                        //                             }, function(data){
                            
                        //     if(data && data.rows && data.rows[0] && data.rows[0].elements){

                        //         data.rows[0].elements.forEach(function(element,element_i){
                        //             if(element && element.status && element.status == 'OK'){
                        //                 if((element.distance.value / 1000) <= input_raio.val()){
                        //                     $(items[element_i]).removeClass('hidde');
                        //                 }
                        //             }
                        //         });
                        //     }


                        // });

                        // let item_i = 0;

                        $(ceps_arrays).each(function(index, el) {
                            service.getDistanceMatrix({
                                                        origins: [input_cep.val()],
                                                        destinations: el,
                                                        travelMode: google.maps.TravelMode.DRIVING,
                                                        unitSystem: google.maps.UnitSystem.METRIC,
                                                        avoidHighways: false,
                                                        avoidTolls: false
                                                        }, function(data){
                                
                                if(data && data.rows && data.rows[0] && data.rows[0].elements){

                                    data.rows[0].elements.forEach(function(element,element_i){

                                        // console.log(element);
                                        if(element && element.status && element.status == 'OK'){
                                            if(element.distance.value <= (input_raio.val() * 1000)){
                                                // item_i = (index * max_elements) + element_i;
                                                // $(items[element_i]).removeClass('hidde');
                                                // $(items[item_i]).removeClass('hidde');
                                                if(input_type.val() == ''){
                                                    list.find('.item-cep-'+el[element_i].replace(/\D/g, "")+'[data-cep]').removeClass('hidde');
                                                }else{
                                                    list.find('.item-cep-'+el[element_i].replace(/\D/g, "")+'[data-cep][data-type="'+input_type.val()+'"]').removeClass('hidde');
                                                }
                                            }
                                        }
                                    });
                                }


                            });
                        });
                    }else{
                        if(input_type.val() == ''){
                            items.removeClass('hidde');
                        }else{
                            items.addClass('hidde');
                            list.find('[data-type="'+input_type.val()+'"]').removeClass('hidde');

                        }
                    }

                    setTimeout(function(){
                        list.customScrollbar("resize",true);
                    },50);
                    setTimeout(function(){
                        list.customScrollbar("resize",true);
                    },200);
                    setTimeout(function(){
                        list.customScrollbar("resize",true);
                    },700);

                });
            }


        }
    }


    // $('.bp-image-phrase-section').stellar();

    $('[custom-modal-id]').click(function(event) {
        if($('#'+$(this).attr('custom-modal-id')).length > 0){
            $('body').addClass('custom-modal-active');
            $('body').addClass('no-scroll');
            $('#'+$(this).attr('custom-modal-id')).addClass('active');

        }
    });

    $('.bp-custom-modal-bg, .bp-custom-modal-close').click(function(event) {
        setTimeout(function(){
            $('body').removeClass('custom-modal-active');
            $('body').removeClass('no-scroll');
        },300);
        $('.bp-custom-modal-container').removeClass('active');
    });



    if($('.bp-cookie-alert').length > 0){

        var beef_passion_cookie_alert = $('.bp-cookie-alert')[0];
        var wp_beef_passion_cookie = readCookie('wp_beef_passion_cookie');
        if(wp_beef_passion_cookie && wp_beef_passion_cookie == 'true'){

        }else{
            $(beef_passion_cookie_alert).addClass('active');
            
            $(beef_passion_cookie_alert).find('.bp-cookie-alert-accept').click(function(event) {
                createCookie('wp_beef_passion_cookie', 'true', 365);
                $(beef_passion_cookie_alert).removeClass('active');
            });

            $(beef_passion_cookie_alert).find('.hide-cookie-alert').click(function(event) {
                $(beef_passion_cookie_alert).removeClass('active');
            });

        }
    }


    if($('.bp-site-info-modal').length > 0){

        // var beef_passion_cookie_alert = $('.bp-cookie-alert')[0];
        var bp_site_info_modal = $('.bp-site-info-modal');
        var bp_site_info_modal_num = $('.bp-site-info-modal').data('num');
        var wp_beef_passion_info = readCookie('wp_beef_passion_info-'+bp_site_info_modal_num);

        if(wp_beef_passion_info && wp_beef_passion_info == 'true'){

        }else{

            bp_site_info_modal.modal('show');

            // $(beef_passion_cookie_alert).addClass('active');
            
            // $(beef_passion_cookie_alert).find('.bp-cookie-alert-accept').click(function(event) {
            //     createCookie('wp_beef_passion_info-'+bp_site_info_modal_num, 'true', 365);
            //     $(beef_passion_cookie_alert).removeClass('active');
            // });

            // $(beef_passion_cookie_alert).find('.hide-cookie-alert').click(function(event) {
            //     $(beef_passion_cookie_alert).removeClass('active');
            // });

        }

        bp_site_info_modal.on('hidden.bs.modal', function(e) {
            // console.log(this);
            createCookie('wp_beef_passion_info-'+bp_site_info_modal_num, 'true', 365);
        });
    }



    $('.churrascometro-inputs .item .input').each(function(index, el) {
        let input = $(el).find('input')[0];
        let minus = $(el).find('.minus')[0];
        let plus = $(el).find('.plus')[0];

        minus.input = input;
        plus.input = input;

        $(minus).click(function(event) {
            this.input.value--;
            if(this.input.min && this.input.value < this.input.min){
                this.input.value = this.input.min;
            }
        });
        $(plus).click(function(event) {
            this.input.value++;
            if(this.input.max && this.input.value > this.input.max){
                this.input.value = this.input.max;
            }
        });
    });



    $('.input-num').each(function(index, el) {
        let input = $(el).find('input');
        let up = $(el).find('.input-num-up');
        let down = $(el).find('.input-num-down');

        if(input[0].min){
            el.min = parseInt(input[0].min);
        }
        if(input[0].max){
            el.max = parseInt(input[0].max);
        }

        // console.log(input);
        // console.log(up);
        // console.log(down);
        // console.log(el.min);
        // console.log(el.max);

        input.change(function(event) {
            if((el.min || el.min === 0) && parseInt(this.value) < el.min){
                this.value = el.min;
            } 
            if((el.max || el.max === 0) && parseInt(this.value) > el.max){
                this.value = el.max;
            }
        });

        up.click(function(event) {
            let tempVal = input.val();
            if((el.max || el.max === 0) && (parseInt(tempVal) + 1) > el.max){

            }else{
                input.val(parseInt(input.val()) + 1) ;
            }

            if(tempVal != input.val()){
                input.change();
            }
        });

        down.click(function(event) {
            let tempVal = input.val();
            if((el.min || el.min === 0) && (parseInt(input.val()) - 1) < el.min){

            }else{
                input.val(parseInt(input.val()) - 1) ;
            }

            if(tempVal != input.val()){
                input.change();
            }
        });
    });



    $('.modal-iamge-text[data-target]').click(function(event) {
        $($(this).data('target')).find('.bp-image-text-modal-img').prop('src',$(this).data('modal-img'));
        $($(this).data('target')).find('.bp-image-text-modal-text').html($(this).find('.modal-text').html());
    });



    $('.bp-churrascometro-section').each(function(index, el) {
        let start = $(el).find('.bp-churrascometro-start');
        let result = $(el).find('.bp-churrascometro-result');
        let men = $(el).find('.input-men');
        let women = $(el).find('.input-women');
        let kids = $(el).find('.input-kids');
        let btn_start = $(start).find('.action-btn');
        let btn_result = $(result).find('.action-btn');
        
        let grams_per_person = 400;
        let grams_per_person_unaccompanied = 500;

        btn_start.click(function(event) {
            
            let person_total = parseInt(men.val()) + parseInt(women.val()) + (parseInt(kids.val()) / 2);

            let grams_total = grams_per_person * person_total;
            let grams_total_unaccompanied = grams_per_person_unaccompanied * person_total;

            result.find('.item.accompanied .weight').text((grams_total / 1000).toLocaleString()+' Kg');
            result.find('.item.unaccompanied .weight').text((grams_total_unaccompanied / 1000).toLocaleString()+' Kg');

            if(person_total < 10){
                result.find('.result-text').html('<p>De acordo com a quantidade de pessoas invista em poucos tipos de cortes</p>');
            }else{
                result.find('.result-text').html('<p>De acordo com a quantidade de pessoas é possível oferecer mais opções de cortes</p>');
            }

            start.addClass('d-none');
            result.addClass('active');

            // let btn_text = btn.text();
            // btn.text(btn.data('toggle-text'));
            // btn.data('toggle-text',btn_text);

        });

        btn_result.click(function(event) {
                       
            start.removeClass('d-none');
            result.removeClass('active');

        });

    });


    var playerArgs = {
       icon_play: '<span class="icon-play"></span>', 
       icon_pause: '<span class="icon-pause"></span>', 

    }


    $('.pd-player').pdplayer(playerArgs);


    $('.bp-shop-orde').change(function(event) {
        window.location.href = (this.value);
    });



    $('.bp-account-section').each(function(index, el) {
        $(el).find('.account-nav-item[href^="#"]').click(function(event) {
            $(el).find('.account-tab').removeClass('active');
            $(el).find('.account-tab'+this.getAttribute("href")).addClass('active');
            event.preventDefault();
        });

        $(el).find('.account-nav-item[href^="#"]').first().click();

        if(vars_GET.tab == 'pedidos'){
            $(el).find('.account-nav-item[href^="#shop-orders"]').first().click();

        }
    });


    $('.form-address').each(function(index, el) {
        let address_input = $(el).find('.form-address-input');

        $(el).find('.add-address-btn').click(function(event) {
            $('.bp-add-address-modal').each(function(index_m, el_m) {
                el_m.form = el;
            });
        });


        address_input.change(function(event) {
            let list_html = '';

            if(isJson(this.value)){

                let list = JSON.parse(this.value);

                if (list.length > 0) {
                    list.forEach(function(item,ide) {
                        list_html += '<div class="address-item">'
                                            +'<p class="name">'+item.name+' '+item.last_name+'</p>'
                                            +'<p class="company">'+item.company+'</p>'
                                            +'<div class="infos">'
                                                +'<p><b>Endereço:</b> <span>'+item.address+' - N° '+item.number+'</span></p>'
                                                +'<p><b>Complemento:</b> <span>'+item.complement+'</span></p>'
                                                +'<p><b>Bairro:</b> <span>'+item.district+'</span></p>'
                                                +'<p><b>Cidade:</b> <span>'+item.city+'</span></p>'
                                                +'<p><b>Estado:</b> <span>'+item.state+'</span></p>'
                                                +'<p><b>Cep:</b> <span>'+item.cep+'</span></p>'
                                            +'</div>'
                                            +'<button class="remove" type="button" data-index="'+ide+'">Remover</button>'
                                        +'</div>';
                    });

                    
                }

            }


            $(el).find('.address-list').html(list_html);
            if(list_html){
                $(el).find('.address-list .address-item .remove').click(function(event) {
                    let list = address_input.val();
                    if(isJson(list)){
                        list = JSON.parse(list);
                        let position = $(this).data('index');
                        list.splice(position,1);
                        address_input.val(JSON.stringify(list));
                        address_input.change();
                    }
                });
            }
        });

        $(el).find('.form-address-input').change();
    });


    $('.bp-add-address-modal').each(function(index, el) {
        clear_form_errors(el);

        var input_name = $(el).find('.address-name');
        var input_last_name = $(el).find('.address-last-name');
        var input_company = $(el).find('.address-company');
        var input_cep = $(el).find('.address-cep');
        var input_address = $(el).find('.address-address');
        var input_number = $(el).find('.address-number');
        var input_complement = $(el).find('.address-complement');
        var input_district = $(el).find('.address-district');
        var input_city = $(el).find('.address-city');
        var input_state = $(el).find('.address-state');

        input_cep.on('change keyup',function(event) {
            var val = this.value.replace(/\D/g, "");
            if(val.length > 4){

                while(val.length < 8){
                    val = "0"+val;
                }
                $.ajax({
                    url: 'https://viacep.com.br/ws/'+val+'/json/',
                    dataType: 'json',

                    success: function(response) {

                        if(response.erro){
                            return;
                        }

                        input_state.val(response.uf);
                        input_state.change();
                        input_city.val(response.localidade);
                        input_city.change();
                        input_address.val(response.logradouro);
                        input_address.change();
                        input_district.val(response.bairro);
                        input_district.change();
                        
                    },
                    error: function(erro){
                        // console.log(erro);
                    }
                });
            }
            
        });


        $(el).find('.bp-form-submit').click(function(event) {
            let error = validate_form(el);
            let page_total_value = $('.bp-shop-cart-section .cart-total .total');

            if(!error){
                let form_input = $(el.form).find('.form-address-input');
                let address_list = [];
                
                let data = {
                                name: input_name.val(),
                                last_name: input_last_name.val(),
                                company: input_company.val(),
                                cep: input_cep.val(),
                                address: input_address.val(),
                                number: input_number.val(),
                                complement: input_complement.val(),
                                district: input_district.val(),
                                city: input_city.val(),
                                state: input_state.val(),
                            };

                if( $(el).hasClass('-ajax')){

                    let dados_envio = {
                        'nonce': js_global.admin_nonce,
                        'action': 'user_add_address',
                        'address': JSON.stringify( data),
                    }

                    if(el.billing){
                        dados_envio['billing'] = true;
                        dados_envio['order_id'] = el.order_id;
                    }


                    $.ajax({
                        url: js_global.xhr_url,
                        type: 'POST',
                        data: dados_envio,
                        dataType: 'JSON',
                        beforeSend: function(){
                            
                        },
                        complete: function(){
                            
                        },
                        error: function(erro){
                            // console.log(erro);
                            // alert('Erro!');
                            alert('Erro de comunicação com o servidor');
                        },
                        success: function(response) {
                            // console.log('success');
                            // response = JSON.parse(response);
                            // console.log(response);

                            if(response.error){
                            
                                alert('Ocorreu um erro. Recarregue a pagina e tente novamente');

                            }else if(response.success){

                                if(response.redirect && response.redirect == true){
                                    location.href = response.redirect_url;
                                }else{
                                    // form_input = $('.bp-shop-cart-section .shipping .address-input');
                                    form_input = el.form_input;
                                    form_input.val(JSON.stringify(data));
                                    form_input.change();
                                    
                                    load_shippings(response.shipping_list);
                                    page_total_value.html(response.cart_value_formated);
                                }

                                
                            }else{
                                alert('Ocorreu um erro. Tente novamente mais tarde, se o erro persistir entre em contato com nossa equipe.');
                            }

                        }
                    });


                    
                    $(el).modal('hide');
                }else{


                    if(isJson(form_input.val())){
                        address_list = JSON.parse(form_input.val());
                    }
                    address_list.push(data);

                    form_input.val(JSON.stringify(address_list));
                    form_input.change();
                    $(el).modal('hide');
                }
                
            }
        });

        $(el).on('hide.bs.modal', function () {
            $(this).find('input').val('');
            $(this).find('textarea').val('');
            $(this).find('select').val('');
            force_clear_form_errors(el);
        });
    });

    
}(window.jQuery, window, document));